export default {
    loadingNotifications(state) {
        state.loading = true;
    },
    successNotifications(state, notifications) {
        state.loading = false;
        state.success = true;
        state.error = false;
        state.data = notifications;
    },
    errorNotifications(state, error) {
        state.loading = false;
        state.success = false;
        state.error = error;
        state.data = [];
    },
    resetSuccessNotifications(state) {
        state.success = false;
    },
    setViewedNotif(state, notification) {
        state.willVisualize.data = notification;
    },
    loadingViewedNotif(state) {
        state.willVisualize.loading = true;
    },
    successViewedNotif(state) {
        state.willVisualize.loading = false;
        state.willVisualize.success = true;
        state.willVisualize.error = false;
        state.willVisualize.data = [];
    },
    errorViewedNotif(state, error) {
        state.willVisualize.loading = false;
        state.willVisualize.success = false;
        state.willVisualize.error = error;
        state.willVisualize.data = [];
    },
    resetSuccessViewedNotif(state) {
        state.willVisualize.success = false;
    },
};
